import loadable from '@loadable/component'

export const ReportViewer = loadable(() => import('./ReportViewer'))
export type { ReportProps, FileProps } from './ReportViewer'
